import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  Output,
} from '@angular/core';

import { WINDOW } from '@ng-web-apis/common';
import {
  ColDef,
  ValueFormatterParams,
  ValueGetterParams,
} from '@ag-grid-community/core';
import { LiteratureFundDocumentService } from '../services/literature-fund-document.service';
import { LiteratureDocument, LiteratureDocumentListingData } from '@types';
import { LiteratureGlobalConfigService } from '@literature/services/literature-global-config.service';
import { ResponsiveService } from '@frk/eds-components';
import { Observable } from 'rxjs';

interface FundCard {
  colId: string;
  label: string;
  val: string;
}
interface RendererData {
  data?: LiteratureDocumentListingData;
}
@Component({
  selector: 'ft-fund-document-card',
  templateUrl: './fund-document-card.component.html',
  styleUrls: ['./fund-document-card.component.scss'],
})
export class FundDocumentCardComponent implements OnChanges {
  @Input() rowData: LiteratureDocumentListingData;
  @Input() columnDefs: ColDef[];
  @Input() gridContext: any;
  convertDateTo: string;
  isIntel: boolean;
  rendererData: RendererData = { data: {} };
  renderParams: RendererData = {};
  @Output()
  selectionEmitter = new EventEmitter<LiteratureDocumentListingData>();

  finalRow: FundCard[] = [];
  isMobile$: Observable<boolean>;
  constructor(
    @Inject(WINDOW) readonly windowRef: Window,
    private literatureFundDocumentService: LiteratureFundDocumentService,
    private literatureConfig: LiteratureGlobalConfigService,
    private responsiveService: ResponsiveService
  ) {
    this.isMobile$ = this.responsiveService.isMobile$();
  }
  ngOnChanges() {
    if (this.rowData && this.columnDefs && this.columnDefs.length > 0) {
      this.processSections();
    }
    this.rendererData = this.renderParams;
    this.rendererData.data = this.rowData;
    if (!this.isIntel) {
      this.rendererData = {
        ...this.rendererData,
        ...{ showPublicationDate: true },
      };
    }
  }
  public processSections(): void {
    this.convertDateTo = this.literatureConfig.dateFormat;
    this.isIntel = this.literatureConfig.isInternational;
    this.finalRow = [];
    this.columnDefs.forEach((col) => {
      this.finalRow.push(this.processCol(col));
    });
  }

  goToLink(litData: LiteratureDocument) {
    this.windowRef.open(
      litData?.cmsExternalLink
        ? litData?.cmsExternalLink
        : this.literatureFundDocumentService.getDownloadUrl(
            litData?.literatureHref
          ),
      '_blank'
    );
  }

  processCol(colDef: ColDef): FundCard {
    const colId = colDef.colId || '';
    const label = colDef.headerName || '';
    let val;
    if (colDef.cellRendererParams) {
      this.renderParams = {
        ...colDef.cellRendererParams,
        ...this.renderParams,
      };
    }
    if (colDef.valueFormatter) {
      if (typeof colDef.valueFormatter === 'string') {
        val = colDef.valueFormatter;
      } else {
        val = colDef.valueFormatter({
          data: this.rowData,
          value: this.rowData.literatureData.frkReferenceDate,
          context: this.gridContext,
        } as ValueFormatterParams);
      }
    } else if (colDef.valueGetter) {
      if (typeof colDef.valueGetter === 'string') {
        val = colDef.valueGetter;
      } else {
        val = colDef.valueGetter({
          data: this.rowData,
          context: this.gridContext,
        } as ValueGetterParams);
      }
    } else if (colDef.cellRenderer) {
      if (typeof colDef.cellRenderer === 'string') {
        val = colDef.cellRenderer;
      } else {
        // TODO
      }
    }
    // TODO: extract caveats and tooltips
    return {
      colId,
      label,
      val,
    };
  }
  onSelectionChanged(event: Event, data: LiteratureDocumentListingData) {
    this.rowData.literatureData.isSelected = !this.rowData.literatureData
      .isSelected;
    this.selectionEmitter.emit(data);
  }
}
